import { buildGraphqlQuery } from '@ztechapps/common.utils'
import type { UseListProps, UseListResult } from '../useList'
import { useList } from '../useList'
import type { SetOptional } from 'type-fest'
import type { History } from '@ztechapps/common.contract'
import { gql } from '@apollo/client'

const documentFragment = gql`
  fragment historyFragment on History {
    _id
    entity
    entityKey
    timeStamp
    description
    author
    diff
  }
`

const queries = buildGraphqlQuery('History', documentFragment)

export const useEntityHistory = ({
  query,
  filter,
  options,
  limit = 100,
  ...rest
}: SetOptional<UseListProps, 'entity' | 'sort' | 'query'>): UseListResult<History> => {
  query = query ?? queries?.allConfig?.query

  return useList<History>({
    ...rest,
    query,
    entity: 'allHistory',
    options,
    filter,
    limit,
    sort: { timeStamp: -1 },
  })
}
